module.exports = __webpack_public_path__ + "img/disease-pic4.340365e3.png";